import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Content, Platform, ModalController } from 'ionic-angular';
import { PhotoLibrary } from './../../../../providers/my-photo-library';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { CallNumber } from '@ionic-native/call-number';
import { AbstractPage } from '../../../_com/abstract-page';
import { ReservePickupEditPage } from '../edit/reserve-pickup-edit'
import { ReserveAction } from '../../../../actions/reserve.action';
import { Subscription } from 'rxjs/Subscription';
import { BasicState } from '../../../../states/basic-state';
import Utils from '../../../../_com/utils';
import _ from 'underscore';


/**
 * Generated class for the ReserveDetailPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-reserve-pickup-detail',
  templateUrl: 'reserve-pickup-detail.html',
})
export class ReservePickupDetailPage extends AbstractPage{

  data:any;
	child      = {};
  reserve    = {};
  pickupData = {};
  pickup     = {};
  family     = {};

  onChangePickupDetail:Subscription;

  _utils = Utils;

  @ViewChild(Content) content: Content;
  constructor(
  	public navCtrl: NavController,
  	public navParams: NavParams,
    public reserveAction:ReserveAction,
    private pv:PhotoViewer,
    private pl:PhotoLibrary,
    private plt:Platform,
    private callNumber:CallNumber,
    private basicState:BasicState,
    private modalController: ModalController
  	) {
    super();

    this.drawScreen(this.navParams.data.reserve);
    // 送迎情報を取得

    this.child = this.navParams.data.child[0].data.Child;
    this.pl;  //for TSLint
    this.pv;  //for TSLint
    this.plt;  //for TSLint
    this.callNumber;  //for TSLint

    /**
     * 送迎情報情報が更新されたイベント
     */
    this.onChangePickupDetail = this.basicState.onChangePickupDetail.subscribe((data)=>{
      this.dataReload(this.data["id"]);
    })
  }

  /**
   * 時間を見やすい形に変換
   */
     convertTime(data) {
      if (!data) return "-";
      return this._Utils.date.format(new Date(data), "HH:mm");
    }

  /**
   * 画面が呼び出される前にロード
   */
   ionViewDidLoad() {
    this.dataReload(this.data["id"]);
  }

  /**
   * 画面遷移時イベント
   */
  ionViewDidEnter(){
    this.dataReload(this.data["id"]);
  }


  /**
   * データを再読込する
   */
   dataReload(reserveId){

    this.reserveAction.getList({id:reserveId}).subscribe((res)=>{
      this.drawScreen(res.data[0]["Reserve"]);
    });
  }

  /**
   * 画面に描画する
   */
  drawScreen(reserveData){
    this.data = reserveData;
    this.child = this.data.children[0].data.Child;
  }

  /**
   * 編集ページへ移動
   */
  edit() {
    //編集用データ準備（家族データ）
    var family = this.data.family.data.Family;
    var children = [];
    for(var index in this.data.children){
      var d = this.data.children[index]["data"];
      children.push(d);
    }
    family["children"] = children;

    //編集用データ
    var data = {
      id:this.data.id,
      date:new Date(this.data.datetime.input.date),
      time:[new Date(this.data.datetime.input.time[0]), new Date(this.data.datetime.input.time[1])],
      family:family,
      type:this.data.type,
      bathRequest: this.data.bathRequest,
      status: this.data.status,
      pickup: this.data.pickup,
    };

    // this.navCtrl.push(ReservePickupEditPage, data);

    // モーダルで表示する
    // - 端末をご家族の方に渡す場合があるので、編集時はパスワードロックを行う
    const modal = this.modalController.create(  ReservePickupEditPage,data, { enableBackdropDismiss: false });
    modal.onDidDismiss(() => {
      // 戻ってきたら画面をリフレッシュする
      this.ionViewDidEnter();
    });

    modal.present();
  }

  /**
   * subscription破棄
   */
   ngOnDestroy(){
    this.onChangePickupDetail.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/pages/reserve/pickup/detail/reserve-pickup-detail.ts